/**
 * Map location type colors – consistent with Ketchup Portal.
 * Location: mobile-portal/src/constants/channelColors.ts
 */

export const LOCATION_TYPE_COLORS: Record<string, string> = {
  'nampost-office': '#ef4444',
  'agent-pos': '#f97316',
  'merchant-store': '#3b82f6',
  atm: '#22c55e',
  warehouse: '#8b5cf6',
  mobile_unit: '#8b5cf6',
};

export const FALLBACK_CHANNEL_COLOR = '#6b7280';

export function getLocationTypeColor(locationType: string): string {
  return LOCATION_TYPE_COLORS[locationType?.trim()] ?? FALLBACK_CHANNEL_COLOR;
}
